import { render, staticRenderFns } from "./DeactivateCompanyAccountDialog.vue?vue&type=template&id=11a5171b&"
import script from "./DeactivateCompanyAccountDialog.vue?vue&type=script&lang=js&"
export * from "./DeactivateCompanyAccountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports